import { useContext, useMemo, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { Button, TextField, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { deleteTemplate } from '/providers/templates-api'
import PageWrapper from '/components/page-wrapper'
import Menu from '/components/templates/template-nav-menu'
import HelpText from '/help/template-delete'

const TemplateDelete = () => {
  const { templateId } = useParams()
  const navigate = useNavigate()
  const { apiSource, apiKey, loadingTemplates, templates, refreshTemplates, processing, setProcessing } = useContext(AppContext)
  const [livePasses, setLivePasses] = useState(null)
  const [confirmation, setConfirmation] = useState('')
  const template = useMemo(() => templates.find(item => item.template_id === templateId) ?? null, [templates, templateId])
  if (!loadingTemplates && (!template || !template.archived)) return <Navigate to='/templates' replace />

  const remove = async deletePasses => {
    setProcessing(true)
    const result = await deleteTemplate({ apiSource, apiKey, templateId, deletePasses })
    setProcessing(false)
    if (result?.passes_exist) return setLivePasses(result.live_pass_count)
    if (result?.error || result?.ok === false) return enqueueSnackbar({ message: result?.error?.message ?? 'Unable to delete template', variant: 'error' })
    await refreshTemplates()
    enqueueSnackbar({ message: 'Template deleted', variant: 'success' })
    navigate('/templates')
  }

  return <PageWrapper title={template ? `Delete Template (${template.name})` : 'Delete Template'} HelpText={HelpText} heading='Delete template' selectedTemplate={template} menu={<Menu template={template} processing={processing} setProcessing={setProcessing} />}>
    <div className='p-5 max-w-2xl flex flex-col gap-5'>
      <Typography variant='h4'>Delete template</Typography>
      {livePasses === null ? <><Typography>This permanently deletes archived template <strong>{template?.name}</strong> and its associated test passes.</Typography><Typography>Smartix first checks whether it has live passes.</Typography><div className='flex gap-3'><Button onClick={() => navigate('/templates')} disabled={processing}>Cancel</Button><Button variant='contained' color='error' onClick={() => remove(false)} disabled={processing}>Check and delete template</Button></div></> : <><Typography>This template has <strong>{livePasses}</strong> live {livePasses === 1 ? 'pass' : 'passes'}.</Typography><Typography>Deleting it will permanently delete those live passes and all associated test passes. Enter <strong>{livePasses}</strong> to confirm.</Typography><TextField label='Live passes to delete' value={confirmation} onChange={event => setConfirmation(event.target.value)} inputProps={{ inputMode: 'numeric' }} error={confirmation !== '' && confirmation !== String(livePasses)} /><div className='flex gap-3'><Button onClick={() => navigate('/templates')} disabled={processing}>Cancel</Button><Button variant='contained' color='error' onClick={() => remove(true)} disabled={processing || confirmation !== String(livePasses)}>Delete passes and template</Button></div></>}
    </div>
  </PageWrapper>
}

export default TemplateDelete
